import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./auth/slice";
import postSlice from "./posts/slice";
import usersSlice from "./users/slice";
import projectSlice from "./projects/slice";
import contentSlice from "./contents/slice";

export const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [postSlice.name]: postSlice.reducer,
    [projectSlice.name]: projectSlice.reducer,
    [usersSlice.name]: usersSlice.reducer,
    [contentSlice.name]: contentSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
